var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrade(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4397 15.5C15.4397 19.09 12.5297 22 8.9397 22C5.3497 22 2.4397 19.09 2.4397 15.5C2.4397 11.91 5.3497 9 8.9397 9C9.1097 9 9.28969 9.01 9.45969 9.02C12.6297 9.27 15.1697 11.81 15.4197 14.98C15.4297 15.15 15.4397 15.33 15.4397 15.5Z",
    fill: "#873BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.4397 8.5C22.4397 12.09 19.5297 15 15.9397 15C15.7697 15 15.5897 14.99 15.4197 14.98C15.1697 11.81 12.6297 9.27 9.45969 9.02C9.44969 8.85 9.4397 8.67 9.4397 8.5C9.4397 4.91 12.3497 2 15.9397 2C19.5297 2 22.4397 4.91 22.4397 8.5Z",
    fill: "#873BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02969 2H3.4397C2.8897 2 2.4397 2.45 2.4397 3V5.59C2.4397 6.48 3.51969 6.93 4.14969 6.3L6.73969 3.71001C7.35968 3.08001 6.91969 2 6.02969 2Z",
    fill: "#7D14FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8497 22.0003H21.4397C21.9897 22.0003 22.4397 21.5503 22.4397 21.0003V18.4103C22.4397 17.5203 21.3597 17.0703 20.7297 17.7003L18.1397 20.2903C17.5197 20.9203 17.9597 22.0003 18.8497 22.0003Z",
    fill: "#7D14FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrade);
export default __webpack_public_path__ + "static/media/trade.719adbda0ca4b1ff44408cbb0362ef58.svg";
export { ForwardRef as ReactComponent };